const ValueTypes = {
  PERCENTAGE: "percentage",
  ABSOLUTE: "absolute",
};

export default ValueTypes;
